<script setup>
import IndexLayout from "@/Layouts/IndexLayout.vue";
import Dialog from "@/Components/Messages/Dialog.vue";
import {Head, usePage} from "@inertiajs/vue3";
import {listenerNavigate, setMessages} from "@/helper.js";
import {onBeforeUnmount, onMounted} from "vue";
import {useThread} from "@/Store/Thread.js";
import {storeToRefs} from "pinia";
import OrderHeader from "@/Pages/Order/Components/OrderHeader.vue";
import OrderData from "@/Pages/Order/Components/OrderData.vue";
import OfferPay from "@/Pages/Offer/Components/OfferPay.vue";
import TelegramLogo from "@/Components/Icons/TelegramLogo.vue";
import {route} from "ziggy-js";

const page = usePage(),
    offer = page.props.offer,
    storeThread = useThread(),
    {thread} = storeToRefs(storeThread)


const getUser = (participants) => {
    return participants.find(participant => participant.user.id !== page.props.auth.user.id).user
}

if (page.props.thread) {
    thread.value = page.props.thread
    thread.value.user = getUser(thread.value.participants)
    setMessages(page.props.messages.data)
} else {
    thread.value = {}
    thread.value.user = offer.user
    setMessages([])
}

onMounted(() => {
    document !== undefined && document.addEventListener('inertia:navigate', listenerNavigate)
})

onBeforeUnmount(() => {
    document !== undefined && document.removeEventListener('inertia:navigate', listenerNavigate)
})

</script>

<template>
    <IndexLayout :title="$t('Buy :offer_title for :product_title on AnyKod. Guaranteed deal, verified seller.', {
        offer_title: offer.title,
        product_title: offer.product.title
    })">
        <Head>
            <meta :content="offer.description" name="description">
            <component is="script" type="application/ld+json">
                {{
                    {
                        "@context": "https://schema.org/",
                        "@type": "Product",
                        "name": offer.title,
                        "image": offer.product.image_url,
                        "description": offer.description,
                        "offers": {
                            "@type": "Offer",
                            "url":  $page.props.ziggy.location,
                            "priceCurrency": $page.props.currency.title,
                            "price": offer.price_currency_formatted.replace(/[^\d.,]/g, '').replace(',', "."),
                            "acceptedPaymentMethod": $page.props.payment_methods.map((el) => el.title),
                            "image": offer.product.image_url
                        }
                    }
                }}
            </component>
        </Head>

        <div
            class=" mx-auto lg:px-0 py-2.5 lg:py-6  px-2 sm:px-0 sm:max-w-[38.75rem]  lg:max-w-[62rem] xl:max-w-[78rem] 2xl:max-w-[87.5rem]">
            <div class="flex flex-col lg:flex-row items-start justify-center gap-2.5">
                <div class="flex flex-col gap-2.5 grow w-full">
                    <OrderHeader :lot="offer.lot"
                                 :offer_properties="offer.offer_properties"
                                 :product="offer.product"
                    />
                    <OrderData as-heading :title="$t('TITLE')" :description="offer.title"/>
                    <OrderData :title="$t('Description')" :description="offer.description" :description-uppercase="false"/>
                    <OfferPay :price="offer.price" class="hidden lg:flex w-full"/>
                </div>
                <Dialog :view-offer="offer"
                        content-classes="w-full lg:w-[33.25rem] xl:w-[48.75rem] shrink-0 max-h-screen max-h-[100vh] lg:max-h-[80vh]"/>
                <OfferPay :price="offer.price" mobile-cta class="flex lg:hidden"/>
            </div>
        </div>
    </IndexLayout>
</template>

<style scoped>

</style>
